var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocumentsearchLarge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 58.26,
    height: 50.26,
    viewBox: "0 0 62.26 62.26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path213",
    d: "M0-682.665H62.26v62.26H0Z",
    transform: "translate(0 682.665)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g207",
    transform: "translate(0 682.665)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g209",
    transform: "translate(0 -682.665)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g211",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g217",
    transform: "translate(5.125 0.912)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path219",
    d: "M0-218.111v-18.24A3.649,3.649,0,0,1,3.648-240h33.54a3.649,3.649,0,0,1,3.648,3.648v3.57",
    transform: "translate(0 239.999)",
    fill: "rgba(0,0,0,0)",
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g221",
    transform: "translate(0.912 22.8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path223",
    d: "M0-171.923v-13.6a3.648,3.648,0,0,1,3.648-3.648h17.8a3.163,3.163,0,0,1,3.068,2.394l.626,2.507a3.161,3.161,0,0,0,3.067,2.394h9.934",
    transform: "translate(0 189.176)",
    fill: "rgba(0,0,0,0)",
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g225",
    transform: "translate(0.912 33.955)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path227",
    d: "M-479.845,0V23.745a3.648,3.648,0,0,1-3.648,3.648h-40.858A3.648,3.648,0,0,1-528,23.745V10.4",
    transform: "translate(527.999)",
    fill: "rgba(0,0,0,0)",
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g229",
    transform: "translate(11.571 6.384)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path231",
    d: "M0,0H26.412",
    fill: "rgba(0,0,0,0)",
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g233",
    transform: "translate(11.571 11.856)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path235",
    d: "M0,0H20.94",
    fill: "rgba(0,0,0,0)",
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g237",
    transform: "translate(11.571 17.328)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path239",
    d: "M0,0H19.116",
    fill: "rgba(0,0,0,0)",
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g241",
    transform: "translate(41.577 33.225)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path243",
    d: "M-23.726,0l-2.381,4.123",
    transform: "translate(26.107)",
    fill: "rgba(0,0,0,0)",
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g245",
    transform: "translate(37.482 30.856)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path247",
    d: "M-23.761,0l-2.384,4.128",
    transform: "translate(26.145)",
    fill: "rgba(0,0,0,0)",
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g249",
    transform: "translate(27.302 34.751)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path251",
    d: "M-20.435-189.755h0a4.1,4.1,0,0,0,5.6-1.5l7.259-12.573A1.736,1.736,0,0,0-8.21-206.2l-4.094-2.364a1.737,1.737,0,0,0-2.372.636l-7.259,12.573A4.1,4.1,0,0,0-20.435-189.755Z",
    transform: "translate(22.485 208.798)",
    fill: "rgba(0,0,0,0)",
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g253",
    transform: "translate(35.287 7.916)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path255",
    d: "M-12.655-73.951A13.047,13.047,0,0,1-.9-81.372a13.045,13.045,0,0,1,13.03,13.03A13.045,13.045,0,0,1-.9-55.311a13.045,13.045,0,0,1-13.03-13.03,13.123,13.123,0,0,1,.086-1.505",
    transform: "translate(13.925 81.372)",
    fill: "rgba(0,0,0,0)",
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g257",
    transform: "translate(40.261 12.89)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path259",
    d: "M-80.281,0a8.065,8.065,0,0,0-8.056,8.056,8.066,8.066,0,0,0,8.056,8.056,8.065,8.065,0,0,0,8.056-8.056A8.065,8.065,0,0,0-80.281,0Z",
    transform: "translate(88.337)",
    fill: "rgba(0,0,0,0)",
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentsearchLarge);
export default __webpack_public_path__ + "static/media/documentsearch_large.3c768458f2214d14fa229e15404e3d12.svg";
export { ForwardRef as ReactComponent };